module.exports = __webpack_public_path__ + "static/media/VIN_verification_platform_in_nigeria.918a4489.png";